import client from './client';

export function getEvents() {
  return client.get('/api/assessments/events');
}

export function createEvent(data) {
  return client.post('/api/assessments/events', data);
}

export function getEvent(eventId) {
  return client.get(`/api/assessments/events/${eventId}`);
}

export function getAssessmentOfflinePackage(eventId) {
  return client.get(`/api/assessments/events/${eventId}/offline-package`);
}

export function exportAssessmentPdf(eventId, data = {}) {
  return client.post(`/api/assessments/events/${eventId}/export-pdf`, data, {
    responseType: 'blob',
  });
}

export function updateEvent(eventId, data) {
  return client.put(`/api/assessments/events/${eventId}`, data);
}

export function deleteEvent(eventId) {
  return client.delete(`/api/assessments/events/${eventId}`);
}

export function getStations(eventId) {
  return client.get(`/api/assessments/events/${eventId}/stations`);
}

export function saveScore(eventId, stationId, data) {
  return client.post(`/api/assessments/events/${eventId}/stations/${stationId}/scores`, data);
}

export function updateAssessmentStationTimerSession(eventId, candidateId, stationCode, data) {
  return client.put(`/api/assessments/events/${eventId}/candidates/${candidateId}/stations/${stationCode}/timer-session`, data);
}
